import React from 'react';
import './PromotionsFold.css';
import { FoldLoader } from '../../components/Fold/FoldLoader';
import { PromotionMain } from '../../components/Fold/PromotionMain';
import { PromotionSecondaries } from '../../components/Fold/PromotionSecondaries';
import { ForceUpdateContext } from '../../../../shared/src/contexts';
import { usePromotionsHook } from '../../../../shared/src/hooks/use-promotions.hook';
import { useForceUpdate } from '../../../../shared/src/hooks/use-force-update.hook';

export const PromotionsFold = () => {
    const { promotionsList, isLoading } = usePromotionsHook();

    // used to rerender promotion with new status when countdown finished
    const { forceUpdate } = useForceUpdate();

    // hide the entire component if no main promotion
    if (promotionsList && !promotionsList.main) {
        return null;
    }
    return <section className="asg-promotion-fold">
        <div className="asg-promotion-fold__content">
            {isLoading && <FoldLoader />}
            {!isLoading && (
                <ForceUpdateContext.Provider value={forceUpdate}>
                    <PromotionMain promotion={promotionsList.main}/>
                    <PromotionSecondaries secondaryPromotions={promotionsList.secondary}/>
                </ForceUpdateContext.Provider>
            )}
        </div>
    </section>;
};
